import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import ro from './locales/ro.json'

const savedLocale = typeof localStorage === 'undefined' ? null : localStorage.getItem('locale')

const i18n = createI18n({
  legacy: false,
  locale: savedLocale || 'ro',
  fallbackLocale: 'en',
  globalInjection: true,
  missingWarn: import.meta.env.DEV,
  fallbackWarn: import.meta.env.DEV,
  messages: { en, ro },
})

export default i18n
